export default __webpack_public_path__ + "static/media/logo.edeaa583.svg";